module.exports = __webpack_public_path__ + "static/media/purchase-blue.9f404ee0.png";